import React, { useEffect, useState } from 'react';
import RemittanceRibbenBox from './RemittanceRibbenBox';
import RemittanceDetailTabs from './RemittanceDetailTabs';
import { fetchRemittanceDetail } from '../../../src/store/slices/remittance';
import { useDispatch,useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import FullPageLoader from '../../../src/common/FullPageLoader';
import { getMasterConfig } from '../../../src/store/slices/common';
import { COUNTRY_CODE, APP_COUNTRY } from '../../config/constant';
import RemittanceDetailTabsId from './RemittanceDetailTabsId';

interface RemittancePayload {
  id: string;
  remittance_type?: string;
}

const RemittanceDetail: React.FC = () => {
    const { id,type } = useParams<{ id: string,type:string }>()
    const dispatch: any = useDispatch();
    const [callReloadApi, setCallReloadApi] = useState(0);
    const [isReferralButtonDisabled, setIsReferralButtonDisabled] = useState(true);
    const [isLeadFromAgency, setLeadFromAgency] = useState(false);
    const remittanceDetail = useSelector((state: any) => state.remittance.remittanceDetail);
    const insuranceDetails = useSelector((state: any) => state.remittance.remittanceRibbon);
    const configData = useSelector((state: any) => state.common)
    const [loading, setLoading] = useState<boolean>(false);
    const [remittance_status, setRemittanceStatus] = useState<any>([]);
    const [paymentMadeFrom,setPaymentMadeFrom] = useState<any[]>([]);

    const loadRemittanceDetails = async () => {
        if (id) {
            try{
                setLoading(true);
                let payload:RemittancePayload = { id:id }
                if(COUNTRY_CODE === APP_COUNTRY.APP_TYPE_ID){
                    payload.remittance_type = type;
                }
                await dispatch(fetchRemittanceDetail(payload));
            }catch (error) {
                console.error("Error while fetching Remittance detail:", error);
            }finally {
                setLoading(false);
            }
        }
    };
    useEffect(() => {
        loadRemittanceDetails();
        if (Object.keys(configData.common).length === 0) {
            getMasterConfigApi();
        }
        // eslint-disable-next-line
    }, [id,callReloadApi]);

    useEffect(() => {
        if (Object.keys(configData.common || {}).length === 0) {
            return;
        }

        setRemittanceStatus(configData.common.remittance_status || []);
        setPaymentMadeFrom(configData.common.payment_made_from || []);
    }, [configData.common]);

    const getMasterConfigApi = () => {
        setLoading(true);
        dispatch(getMasterConfig()).then((res: any) => {
            if (res && res.status === 200) {
                if (res.data) {
                    setRemittanceStatus(res.data.remittance_status);
                    setPaymentMadeFrom(res?.data?.payment_made_from)
                }
            }
        }).catch((err: Error) => {
            setLoading(false);
        })
    }

    const remittanceDetails = remittanceDetail;

    return (
        <div className="container-fluid main-outer">
            <FullPageLoader show={loading} />
            <div className="row">
                <RemittanceRibbenBox insuranceDetails={insuranceDetails} remittanceDetail={remittanceDetail}  setCallReloadApi= {setCallReloadApi} callReloadApi= {callReloadApi} isReferralButtonDisabled={isReferralButtonDisabled} isLeadFromAgency={isLeadFromAgency}/>
                {
                    COUNTRY_CODE === APP_COUNTRY.APP_TYPE_PH ? 
                        <RemittanceDetailTabs revenue={insuranceDetails} remittanceDetails={remittanceDetails} callReloadApi = {callReloadApi}  setCallReloadApi = {setCallReloadApi} setIsReferralButtonDisabled={setIsReferralButtonDisabled} setLeadFromAgency={setLeadFromAgency} remittance_status={remittance_status}/>
                    :
                        <RemittanceDetailTabsId remittanceDetails={remittanceDetails} ribbonData={insuranceDetails} callReloadApi = {callReloadApi}  setCallReloadApi = {setCallReloadApi} remittance_status={remittance_status} paymentMadeFrom={paymentMadeFrom}/>
                        // <RemittancePaymentFormID remittanceDetails={remittanceDetails} callReloadApi = {callReloadApi} setCallReloadApi = {setCallReloadApi} remittance_status={remittance_status}></RemittancePaymentFormID>
                }
            </div>
        </div>
    )
}

export default RemittanceDetail;